import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FloatLabelModule } from 'primeng/floatlabel';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { NgxAimStationComplete } from './ngx-aim-station-complete.class';

@Component({
  selector: 'ngx-aim-station-complete',
  standalone: true,
  imports: [
    ButtonModule,
    FormsModule,
    CheckboxModule,
    InputTextareaModule,
    FloatLabelModule,
    ConfirmDialogModule,
  ],
  templateUrl: './ngx-aim-station-complete.component.html',
  styleUrl: './ngx-aim-station-complete.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NgxAimStationCompleteComponent extends NgxAimStationComplete implements OnInit {
  ngOnInit() {
    this.init();
  }
}
